module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Light.ac523705.otf";